import FormRepeater from "../../../../common/FormReapeater.jsx";
import {Card} from "react-bootstrap";
import ButtonWithIcon from "../../../../common/ButtonWithIcon.jsx";
import {Icons} from "../../../../common/Icons.jsx";
import PropTypes from "prop-types";
import TextareaWiz from "../../../../common/inputs/wizard/TextareaWiz.jsx";


export const KamienieMiloweRepeater = (props) => {
    const {row, setRow, parentIdx, parentListName, wiz} = props;
    const listName = "zadanie_km_list";
    const listKey = `${parentListName}.${listName}`;



    return (
        <FormRepeater
            addButtonText={`Dodaj kamień milowy do zadania ${parentIdx + 1}`}
            addButtonTitle="dodaj"
            hideNativeDelete
            onChange={(e) => {
                setRow(listName, e);            }}
            value={row?.zadanie_km_list || []}
            length={row?.zadanie_km_list?.length || 0}
            title="dodaj"
            form={(rowItem, updateRow, idx, remove) => {

                return <div className="flex flex-column w-100 my-4">
                    <Card>
                        <Card.Header>
                            <ButtonWithIcon
                                text={`Usuń kamień milowy ${idx + 1} dla zadania ${parentIdx + 1}`}
                                onClick={() => remove(idx)}
                                icon={<Icons.delete/>}
                                variant="danger"
                                className="d-flex"
                            />
                        </Card.Header>
                        <Card.Body>
                            <TextareaWiz
                                wiz={wiz}
                                idx={idx}
                                keyName={`${parentListName}.${parentIdx}.${listName}.${idx}.nazwa`}
                                row={rowItem}
                                setRow={updateRow}
                            />

                        </Card.Body>
                    </Card>
                </div>
            }}
        />
    );
};

KamienieMiloweRepeater.propTypes = {
    row: PropTypes.any,
    setRow: PropTypes.func.isRequired,
    parentIdx: PropTypes.number.isRequired,
    wiz: PropTypes.object.isRequired,
    parentListName: PropTypes.string.isRequired,
};
